<template>
  <li class="index-item" v-if="indexItem">
    <img
      v-if="indexItem.is(selectedIndex)"
      :src="indexImageS(indexItem)"
    >
    <a
      v-else
      class="index-image"
      @click.prevent="$emit('click', indexItem)"
    >
      <img
        :src="indexImage(indexItem)"
      >
    </a>
  </li>
</template>

<script>
export default {
  name: 'index-item',
  props: {
    indexItem: {
      type: [Object, String],
      default: function () {
        return {}
      }
    },
    selectedIndex: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  methods:{
    indexImageS(indexItem){
      if (!indexItem) return 
      if (this.$route.params.lang === 'ja-JP' && /^[A-Z]{2}$/.test(indexItem.key)) {
        return require(`@images/series/ja-JP/txt_index-${indexItem.value}-s.png`)
      } else if (/^[A-Z]{1}$/.test(indexItem.key)) {
        return require(`@images/series/en-US/txt_index-${indexItem.value}-s.png`)
      }
      return
    },
    indexImage(indexItem){
      if(!indexItem) return
      if (this.$route.params.lang === 'ja-JP' && /^[A-Z]{2}$/.test(indexItem.key)) {
        return require(`@images/series/ja-JP/txt_index-${indexItem.value}.png`)
      } else if (/^[A-Z]{1}$/.test(indexItem.key)) {
        return require(`@images/series/en-US/txt_index-${indexItem.value}.png`)
      }
      return
    }
  },
}
</script>

<style lang="scss" scoped>
.index-item {
  height: 34px;
  display: flex;
  align-items: center;
  padding-top: 10px;
  justify-content: center;
  .index-image {
    cursor: pointer;
  }
}
</style>
